import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService } from '../../shared/services/index';
import { LCRFormService } from '../services/lcr-form.service';



@Injectable()
export class LCRDashboardResolverService implements Resolve<any> {
  customerGuid: string;

  constructor ( private storageManagerService: StorageManagerService,
      private lcrService: LCRFormService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
        if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
        }
    }

    // Both forms and deliveries are loaded via pagination in the component
    const retVal = forkJoin([
      of({ data: [] }), // Empty placeholder for forms
      of({ data: [] })  // Empty placeholder for deliveries
           ]
        )
        .pipe(catchError(err => of(err)));

        return retVal;
    }
}
